import MOMABffService from '@/services/moma-bff.service';
import { Module, VuexModule } from 'vuex-module-decorators';

@Module
export default class TwitterCrisisMonitorModule extends VuexModule {
  bffService = new MOMABffService();

  paginationLimit = 10;
}
